import(/* webpackMode: "eager", webpackExports: ["Countdown"] */ "/vercel/path0/frontend/src/app/sdc/components/Countdown/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureListContainer","Feature"] */ "/vercel/path0/frontend/src/app/sdc/components/FeaturesList/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["HeadContainer","Section","SmallTitle","Description","MoreInfo","InstagramContainer","SubscribeButton"] */ "/vercel/path0/frontend/src/app/sdc/components/Head/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["MobileSchedule"] */ "/vercel/path0/frontend/src/app/sdc/components/MobileSchedule/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScheduleDescContainer","SectionTitle","ScheduleTitle","ScheduleSubtitle"] */ "/vercel/path0/frontend/src/app/sdc/components/ScheduleDesc/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SdcSchedule"] */ "/vercel/path0/frontend/src/app/sdc/components/SdcSchedule/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionTitle"] */ "/vercel/path0/frontend/src/app/sdc/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Scrambles"] */ "/vercel/path0/frontend/src/components/Scrambles/index.tsx");
